import React from 'react';
import { JSONSchema7 } from 'json-schema';
import { Text } from 'src/modules/shared/components/atoms/text';
import { getPrimaryType } from 'src/modules/shared/utils/json-schema.util';
import { JSONSchemaFormProps } from 'src/modules/shared/types/json-schema.type';
import { StringField } from 'src/modules/shared/components/atoms/json-schema-inputs/string-field';
import { NumberField } from 'src/modules/shared/components/atoms/json-schema-inputs/number-field';
import { BooleanField } from 'src/modules/shared/components/atoms/json-schema-inputs/boolean-field';

interface SubSchemaFieldsProps {
  schemaKey: string;
  schema: JSONSchema7;
  value: unknown;
  handleChange: (key: string, value: unknown) => void;
  disabled?: boolean;
  JSONSchemaForm: React.ComponentType<JSONSchemaFormProps>;
}

export const SubSchemaFields: React.FC<SubSchemaFieldsProps> = ({
  schemaKey,
  schema,
  value,
  handleChange,
  disabled = false,
  JSONSchemaForm,
}) => {
  const isNullSchema = schema.type === 'null';
  if (isNullSchema) {
    return (
      <Text size="small" color="neutral">
        {/* TODO: check when implementing i18n */}
        Este campo siempre será nulo
      </Text>
    );
  }

  const isNonObjectSchema = schema.type !== 'object';
  if (isNonObjectSchema) {
    const fieldType = getPrimaryType(schema);

    switch (fieldType) {
      case 'string': {
        return (
          <StringField
            id={`field-${schemaKey}`}
            schema={schema}
            value={value}
            onChange={(newValue) => handleChange(schemaKey, newValue)}
            disabled={disabled}
          />
        );
      }
      case 'number':
      case 'integer': {
        return (
          <NumberField
            id={`field-${schemaKey}`}
            schema={schema}
            value={value}
            onChange={(newValue) => handleChange(schemaKey, newValue)}
            disabled={disabled}
            fieldType={fieldType}
          />
        );
      }
      case 'boolean': {
        return (
          <BooleanField
            id={`field-${schemaKey}`}
            schema={schema}
            value={value}
            onChange={(newValue) => handleChange(schemaKey, newValue)}
            disabled={disabled}
          />
        );
      }
      default: {
        return (
          <Text size="small" color="neutral">
            {/* TODO: check when implementing i18n */}
            Tipo no soportado: {fieldType}
          </Text>
        );
      }
    }
  }

  const isObjectSchema = schema.type === 'object';
  if (isObjectSchema && schema.properties) {
    return (
      <JSONSchemaForm
        schema={schema}
        formData={(value as Record<string, unknown>) || {}}
        onChange={(data: Record<string, unknown>) =>
          handleChange(schemaKey, data)
        }
        disabled={disabled}
      />
    );
  }

  return null;
};
